import {
  getAttendancePolicies as getAttendancePoliciesService,
  getAttendancePolicyById as getAttendancePolicyByIdService,
  createAttendancePolicy as createAttendancePolicyService,
  updateAttendancePolicy as updateAttendancePolicyService,
  deleteAttendancePolicy as deleteAttendancePolicyService,
} from "services/company/attendanceManagement/attendancePolicy/attendancePolicyService";

import {
  getPoliciesStart,
  getPoliciesSuccess,
  getPoliciesFailure,
  getPolicyByIdStart,
  getPolicyByIdSuccess,
  getPolicyByIdFailure,
  createPolicyStart,
  createPolicySuccess,
  createPolicyFailure,
  updatePolicyStart,
  updatePolicySuccess,
  updatePolicyFailure,
  deletePolicyStart,
  deletePolicySuccess,
  deletePolicyFailure,
} from "./attendancePolicySlice";

import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all attendance policies
export const fetchAttendancePolicies =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(getPoliciesStart());
      const response = await getAttendancePoliciesService(params);

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(
          getPoliciesSuccess({
            data: response.data || [],
            pagination: response.pagination || {},
          }),
        );
        return { success: true, data: response.data };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to fetch attendance policies";
        dispatch(getPoliciesFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Fetch attendance policies error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to fetch attendance policies";
      dispatch(getPoliciesFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

// Fetch attendance policy by ID
export const fetchAttendancePolicyById = (id) => async (dispatch) => {
  try {
    dispatch(getPolicyByIdStart());
    const response = await getAttendancePolicyByIdService(id);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getPolicyByIdSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg =
        response?.meta?.message || "Failed to fetch attendance policy";
      dispatch(getPolicyByIdFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch attendance policy error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch attendance policy";
    dispatch(getPolicyByIdFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Create attendance policy
export const createAttendancePolicy = (data) => async (dispatch) => {
  try {
    dispatch(createPolicyStart());
    const response = await createAttendancePolicyService(data);

    if (
      (response?.meta?.status === true && response?.meta?.code === 200) ||
      response?.meta?.code === 201
    ) {
      dispatch(createPolicySuccess(response.data));
      showSuccessToast(
        response?.meta?.message || "Attendance policy created successfully",
      );
      return { success: true, data: response.data };
    } else {
      const errorMsg =
        response?.meta?.message || "Failed to create attendance policy";
      dispatch(createPolicyFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Create attendance policy error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to create attendance policy";
    dispatch(createPolicyFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Update attendance policy
export const updateAttendancePolicy = (id, data) => async (dispatch) => {
  try {
    dispatch(updatePolicyStart());
    const response = await updateAttendancePolicyService(id, data);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(updatePolicySuccess(response.data));
      showSuccessToast(
        response?.meta?.message || "Attendance policy updated successfully",
      );
      return { success: true, data: response.data };
    } else {
      const errorMsg =
        response?.meta?.message || "Failed to update attendance policy";
      dispatch(updatePolicyFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Update attendance policy error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to update attendance policy";
    dispatch(updatePolicyFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Delete attendance policy
export const deleteAttendancePolicy = (id) => async (dispatch) => {
  try {
    dispatch(deletePolicyStart());
    const response = await deleteAttendancePolicyService(id);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(deletePolicySuccess(id));
      showSuccessToast(
        response?.meta?.message || "Attendance policy deleted successfully",
      );
      return { success: true };
    } else {
      const errorMsg =
        response?.meta?.message || "Failed to delete attendance policy";
      dispatch(deletePolicyFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Delete attendance policy error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to delete attendance policy";
    dispatch(deletePolicyFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};
